<template>
  <v-dialog
    v-model="showModal"
    max-width="900px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title> Cartões usuário: {{ user.name }} </v-card-title>
      <v-card-text>
        <v-data-table
          :items="creditCards"
          :headers="cardsHeaders"
          :items-per-page="10"
          no-data-text="Nenhum cartão encontrado"
        >
          <template v-slot:item.is_valid="{ item }">
            {{ item.is_valid ? 'Sim' : 'Não' }}
          </template>
          <template v-slot:item.pattern="{ item }">
            {{ item.pattern | filtroPrincipal }}
          </template>
          <template v-slot:item.action="{ item }">
            <ActionButton
              message="Alterar Principal"
              icon="check"
              @onclick="changePattern(item)"
            />
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="hideModal()">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import UserCreditCardController from '../../controllers/UserCreditCardController';
import ActionButton from './ActionButtonsTemplate.vue';
export default {
  components: {
    ActionButton,
  },
  props: {
    user: Object,
    showModal: Boolean,
  },
  watch: {
    user: function () {
      if (this.showModal) this.getUserCreditCard();
    },
  },
  data() {
    return {
      userCreditCardController: new UserCreditCardController(this.$resource),
      creditCards: [],
      creditCardId: null,
      cardsHeaders: [
        { text: 'ID', value: 'id' },
        { text: 'Apelido', value: 'nickname' },
        { text: 'Nome', value: 'credit_card_owner' },
        { text: 'Validado?', value: 'is_valid' },
        { text: 'Principal', value: 'pattern' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
    };
  },
  methods: {
    getUserCreditCard() {
      this.creditCards = [];
      this.userCreditCardController
        .getAllByUserId(this.user.id)
        .then((response) => {
          this.creditCards = response;
        });
    },
    changePattern(item) {
      this.userCreditCardController.changePattern(item.id).then(
        (res) => {
          this.getUserCreditCard();
          this.$awn.success('Cartão principal alterado com sucesso!');
        },
        (error) => {
          this.$awn.alert(error.body.message);
        }
      );
    },
    hideModal() {
      this.$emit('cancel');
    },
  },
  filters: {
    filtroPrincipal(value) {
      return value ? 'Principal' : '';
    },
  },
};
</script>
